import { LwApiPM } from "@techniaorg/liteweb-api";
import { LwTreeData } from "@techniaorg/liteweb-api/dist/types/lw-public-api";
import { waitForIFrameAndModel } from "../src/util";

// Wait until the iframe is loaded
const myframe = document.querySelector("iframe#webviewer") as HTMLIFrameElement;
let LwAPI: LwApiPM | null = null;
const apiReady: Promise<LwApiPM | null> = waitForIFrameAndModel(myframe)
  .then((api) => {
    LwAPI = api;
    LwAPI.registerOnSelection(function (selectedItem) {
      console.log(
        selectedItem.item.modelId + ":" + selectedItem.item.modelItemId
      );
    });
    return api;
  })
  .catch((e) => {
    console.log("LwAPI could not be initialized: ", e);
    return null;
  });

function ex_showall() {
  LwAPI?.getTree().then((tree) => {
    let treeData: LwTreeData | null = null;
    if (Array.isArray(tree)) {
      treeData = tree[0];
    } else treeData = tree;
    LwAPI?.setNodeVisibility(treeData.modelKey + ":" + 1, true);
  });
}

function ex_isolate(id: string) {
  LwAPI?.getTree().then((tree) => {
    let treeData: LwTreeData | null = null;
    if (Array.isArray(tree)) {
      treeData = tree[0];
    } else treeData = tree;
    LwAPI?.isolate(treeData.modelKey + ":" + id);
  });
}

// Bind functions to buttons
document.getElementById("isolate")?.addEventListener("click", async () => {
  await apiReady;
  ex_isolate("846");
});
document.getElementById("showall")?.addEventListener("click", async () => {
  await apiReady;
  ex_showall();
});
